export const convertToHtml = (description) => {
  return description.replace(/\n/g, ` <br/>`);
}